module.exports = __webpack_public_path__ + "static/media/order-step-1.578fe717.png";